import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=591c4faa&scoped=true&"
import script from "./DocumentsView.vue?vue&type=script&lang=js&"
export * from "./DocumentsView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=591c4faa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c4faa",
  null
  
)

export default component.exports